export default __webpack_public_path__ + "static/media/AskMeLogo.73e44753.jp2";